import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { NbDialogService } from "@nebular/theme";
import { format, render, cancel, register } from "timeago.js";
import { environment } from "../../../environments/environment";
import { User } from "../../@core/data/users";
import { DialogProfileComponent } from "../dialog-profile/dialog-profile.component";

@Component({
  selector: "ngx-view-user-display",
  styleUrls: ["./view-user-display.component.scss"],
  templateUrl: "./view-user-display.component.html",
})
export class ViewUserDisplayComponent implements OnInit {
  @Input() user?: User;
  @Input() mode?: string = "name"; //name / avatar / detail
  @Input() icon?: string = ""; //at-outline
  @Input() uid?: string = "";
  @Input() name?: string = "";
  @Input() imageURL?: string = "";
  @Input() size?: string = "large";
  @Output() onClick: EventEmitter<any> = new EventEmitter();

  imagePath: string =
    environment.imageKit.urlEndpoint + "/tr:n-media_library_thumbnail/users/";

  shortName: string = "";

  constructor(private dialogService: NbDialogService) {}

  ngOnInit(): void {
    if (this.user) {
      this.uid = this.user.uid;
      this.name = this.user.displayName;
      this.imageURL = this.user.photoURL
        ? this.user.photoURL.replace(
            "https://ik.imagekit.io/kasoft/",
            "https://ik.imagekit.io/kasoft/tr:n-media_library_thumbnail/"
          )
        : "https://ik.imagekit.io/kasoft/tr:n-media_library_thumbnail/users/default";

      this.shortName = this.user.displayName
        ? this.user.displayName.split(" ")[
            this.user.displayName.split(" ").length - 1
          ]
        : "N/A";
    } else {
      this.uid = this.uid !== "" ? this.uid : "";
      this.imageURL =
        this.imageURL !== ""
          ? this.imageURL
          : "https://ik.imagekit.io/kasoft/tr:n-media_library_thumbnail/users/default";
      this.name = this.name !== "" ? this.name : "Ẩn danh";
      this.shortName = "User";
    }
  }

  viewProfile() {
    // if (this.uid !== "") {
    //   this.dialogService.open(DialogProfileComponent, {
    //     context: {
    //       header: "Thông tin tài khoản",
    //       userId: this.uid,
    //     },
    //     closeOnBackdropClick: false,
    //   });
    // }
    this.onClick.emit(true);
  }
}
